$(document).ready( function () {
  $(document).on('click', '.collection-bundel-add-to-cart', function (event) {
    var formData = $(this).parents('#add-item-form').serialize();
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: formData,
      dataType: 'json',
      encode: true,
    }).done( function (data) {
      $.ajax({
        type: 'GET',
        url: window.location.href,
      }).done( function (html) {
        document.body.style.overflow = 'hidden';
        document.getElementById('cart-drawer-for-js').innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector('#cart-drawer-for-js').innerHTML;
        $('cart-drawer').addClass('active');
      });
    });
    event.preventDefault();
  });

  $(document).on('click', '#CartDrawer-Overlay, .drawer__close', function (event) {
    document.body.style.overflow = 'auto';
  })
});